import { render, staticRenderFns } from "./AnimalsList.vue?vue&type=template&id=4b4a5c96&scoped=true&"
import script from "./AnimalsList.vue?vue&type=script&lang=js&"
export * from "./AnimalsList.vue?vue&type=script&lang=js&"
import style0 from "./AnimalsList.vue?vue&type=style&index=0&id=4b4a5c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a5c96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
